/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

jQuery(document).ready(function(){
function cartCountNew(){
  jQuery.getJSON('/cart.js', function(cart) {
    var c_count = cart.item_count;
    // console.log('Cart item count:', cart.item_count);
    jQuery(".cart_menu span.Header__CartCount").text(c_count)
    if(c_count == 0){
       jQuery(".cart_menu .Header__CartDot").removeClass("is-visible")
    }
    if(c_count > 0){
       jQuery(".cart_menu .Header__CartDot").addClass("is-visible")
    }
  });
}
  cartCountNew();

  setInterval(()=>{
    cartCountNew();
  }, 4000)
  
  jQuery(".our_groom.Container .shopify-section.shopify-section--bordered").each(function(){
    var title=jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').text();
          jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').attr('id',title);  
    
     jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').addClass('h2_custom');  
     
  });
  
   jQuery(".our_groom.Container .shopify-section.shopify-section--bordered .ProductItem__Wrapper").mouseenter(function(){
    var title=jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').text();
          jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').attr('id',title);  
    
     jQuery(this).find('.ProductItem__Info.ProductItem__Info--center').slideDown(); 
        jQuery(this).find('.ProductItem__Info.ProductItem__Info--center').animate({top: "0"});
     
  });
  
  
  
    jQuery(".our_groom.Container .shopify-section.shopify-section--bordered .ProductItem__Wrapper").mouseleave(function(){
    var title=jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').text();
          jQuery(this).find('h2.SectionHeader__Heading.Heading.u-h1').attr('id',title);  
    
     jQuery(this).find('.ProductItem__Info.ProductItem__Info--center').slideUp(); 
         jQuery(this).find('.ProductItem__Info.ProductItem__Info--center').animate({top: "100%"}); 
     
  });
    jQuery(".all_cateogy_groom a").click(function(){
   
   jQuery(".all_cateogy_groom a").removeClass('active');
   jQuery(this).addClass('active');
  
});

  // Ensure "View product" control on Globo filter cards opens the same PDP as the product image
  jQuery(document).on('click', '.ProductItem__ViewProduct button, .ProductItem__ViewProduct a', function(e){
    e.preventDefault();
    var $card = jQuery(this).closest('.spf-product-card');
    var $imageLink = $card.find('.spf-product-card__image-wrapper').first();
    if ($imageLink.length) {
      window.location.href = $imageLink.attr('href');
    }
  });

  // AJAX Add to Cart for collection page ProductItem__AddToCartForm
  jQuery(document).on('submit', '.ProductItem__AddToCartForm', function(e) {
    e.preventDefault();
    var $form = jQuery(this);
    var $button = $form.find('.ProductItem__AddToCart');
    var variantId = $form.find('input[name="id"]').val();
    var originalText = $button.text();
    
    // Disable button and show loading
    $button.prop('disabled', true).text('Adding...');
    
    // Add to cart via AJAX
    jQuery.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        id: variantId,
        quantity: 1
      }),
      success: function(item) {
        // Update cart count
        cartCountNew();
        
        // Show success message
        $button.text('Added!').addClass('Button--success');
        
        // Dispatch event for theme compatibility
        document.dispatchEvent(new CustomEvent('product:added', {
          detail: {
            variant: item,
            quantity: 1
          }
        }));
        
        // Reset button after 2 seconds
        setTimeout(function() {
          $button.prop('disabled', false).text(originalText).removeClass('Button--success');
        }, 2000);
      },
      error: function(xhr, status, error) {
        // Show error
        $button.text('Error').addClass('Button--error');
        console.error('Add to cart error:', error);
        
        // Reset button after 2 seconds
        setTimeout(function() {
          $button.prop('disabled', false).text(originalText).removeClass('Button--error');
        }, 2000);
      }
    });
  });

  // Fix price display issue - correct prices showing 10x (400,000 instead of 40,000)
  function fixPriceDisplay() {
    // If we are on the Taupe Pintuck Kurta PDP, never auto-correct prices
    try {
      if (window.location && window.location.pathname && window.location.pathname.indexOf('/products/taupe-pintuck-kurta-set') !== -1) {
        return;
      }
    } catch (e) {
      // fail safe – continue normal logic
    }

    // Fix prices with data-money-convertible attribute
    jQuery('[data-money-convertible]').each(function() {
      var $priceEl = jQuery(this);
      var priceText = $priceEl.text().trim();
      var shopCurrency = (window.theme && window.theme.shopCurrency) ? window.theme.shopCurrency : 'INR';
      
      // Get original price from data attribute (before currency conversion)
      var originalPriceAttr = $priceEl.attr('data-currency-' + shopCurrency);
      if (!originalPriceAttr) {
        // If no original price stored, store current as original
        $priceEl.attr('data-currency-' + shopCurrency, priceText);
        return;
      }
      
      // Extract numbers from both prices
      var currentNum = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
      var originalNum = parseFloat(originalPriceAttr.replace(/[^0-9.]/g, '')) || 0;
      
      // If current price is exactly 10x the original, fix it
      if (originalNum > 0 && currentNum > 0 && Math.abs(currentNum - (originalNum * 10)) < 1) {
        // Restore original price
        $priceEl.text(originalPriceAttr);
        // Mark as already converted to prevent re-conversion
        $priceEl.attr('data-currency', shopCurrency);
      }
    });

    // Fix Globo Filter prices (spf-product-card__price, spf-product-card__saleprice, spf-product-card__oldprice)
    jQuery('.spf-product-card__price, .spf-product-card__saleprice, .spf-product-card__oldprice').each(function() {
      var $priceEl = jQuery(this);
      var priceText = $priceEl.text().trim();
      
      // Skip if already fixed (has data-price-fixed attribute)
      if ($priceEl.attr('data-price-fixed') === 'true') {
        return;
      }

      // Do NOT auto-correct price for Taupe Pintuck Kurta Set cards
      try {
        var isTaupePintuck = false;
        var $card = $priceEl.closest('.spf-product-card, .ProductItem');
        if ($card.length) {
          var $link = $card.find('a[href*="/products/"]').first();
          if ($link.length && $link.attr('href').indexOf('taupe-pintuck-kurta-set') !== -1) {
            isTaupePintuck = true;
          }
        }
        if (isTaupePintuck) {
          return;
        }
      } catch (e) {
        // ignore and continue with generic logic
      }
      
      // Extract number from price (e.g., "Rs. 1,350,000.00" -> 1350000)
      var priceMatch = priceText.match(/[\d,]+\.?\d*/);
      if (priceMatch) {
        var priceNum = parseFloat(priceMatch[0].replace(/,/g, ''));
        
        // Check if price is suspiciously high (>= 100,000) and might be 10x
        // Product prices typically range from 1,000 to 999,999 INR
        if (priceNum >= 100000) {
          var correctedPrice = priceNum / 10;
          
          // Fix if corrected price is in reasonable range (1,000 to 999,999)
          // This handles cases like:
          // - 400,000 -> 40,000
          // - 1,350,000 -> 135,000
          // - 450,000 -> 45,000
          if (correctedPrice >= 1000 && correctedPrice <= 999999) {
            // Preserve the currency symbol and format
            var currencySymbol = priceText.replace(/[\d,.\s]/g, '').trim();
            var formattedPrice;
            
            if (currencySymbol) {
              // Format with currency symbol (handle "Rs." or "Rs" or "₹")
              if (currencySymbol.indexOf('Rs') !== -1) {
                formattedPrice = 'Rs. ' + correctedPrice.toLocaleString('en-IN', { maximumFractionDigits: 2 });
              } else if (currencySymbol.indexOf('₹') !== -1) {
                formattedPrice = '₹ ' + correctedPrice.toLocaleString('en-IN', { maximumFractionDigits: 2 });
              } else {
                formattedPrice = currencySymbol + ' ' + correctedPrice.toLocaleString('en-IN', { maximumFractionDigits: 2 });
              }
            } else {
              // Just format the number
              formattedPrice = correctedPrice.toLocaleString('en-IN', { maximumFractionDigits: 2 });
            }
            
            // Update the price
            $priceEl.text(formattedPrice);
            
            // Mark as fixed to prevent re-processing
            $priceEl.attr('data-price-fixed', 'true');
            
            // Prevent currency conversion from running on this element
            $priceEl.removeAttr('data-money-convertible');
            $priceEl.removeClass('money');
          }
        }
      }
    });
  }

  // Run fix after a short delay to allow currency conversion to complete
  setTimeout(fixPriceDisplay, 500);
  
  // Run fix after currency conversion events
  if (window.theme && window.theme.currencyConversionEnabled) {
    // Fix prices when currency selector changes
    jQuery(document).on('change', '.CurrencySelector__Select', function() {
      setTimeout(fixPriceDisplay, 500);
    });
    
    // Override currency conversion to fix prices after conversion
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fixPriceDisplay, 1000);
    });
  }

  // Fix prices when Globo Filter renders products
  if (window.addEventListener) {
    window.addEventListener('globoFilterRenderCompleted', function() {
      setTimeout(fixPriceDisplay, 300);
    });
  }

  // Fix prices on dynamic content load (for AJAX-loaded products)
  var observer = new MutationObserver(function() {
    setTimeout(fixPriceDisplay, 300);
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Also run fix periodically for Globo Filter products that load after page load
  setInterval(function() {
    if (jQuery('.spf-product-card__price, .spf-product-card__saleprice').length > 0) {
      // Only fix prices that haven't been fixed yet
      var unfixedPrices = jQuery('.spf-product-card__price, .spf-product-card__saleprice, .spf-product-card__oldprice').filter(function() {
        return jQuery(this).attr('data-price-fixed') !== 'true';
      });
      if (unfixedPrices.length > 0) {
        fixPriceDisplay();
      }
    }
  }, 1500);
  });